import { useMemo } from 'react';
import { LegalPageLayout } from '../components/legal-page-layout';
import { MarkdownRenderer } from '@/components/ui/markdown-renderer';
import { legalNoticeContent } from '../data/legal-notice-content';
import { extractHeadings } from '../utils/extract-headings';

export function LegalNoticePage() {
  const headings = useMemo(() => extractHeadings(legalNoticeContent), []);

  return (
    <LegalPageLayout title="Aviso Legal" lastUpdated="Marzo 2026" headings={headings}>
      <MarkdownRenderer content={legalNoticeContent} />
    </LegalPageLayout>
  );
}
